import { createApi, fakeBaseQuery } from '@reduxjs/toolkit/query/react';

import BackendApiClient from '../../services/api/BackendApiClient';
import { ORDER_METHODS } from '../../services/exports/Constants';

interface GetDisabledPreOrderDatesParams {
  start_date: string;
  end_date?: string;
  order_method?: ORDER_METHODS;
}

interface GetHolidaysDto {
  params: GetDisabledPreOrderDatesParams;
  companyId: number;
}

interface BusySlotParamsDto {
  date: string;
  order_method: ORDER_METHODS;
  limit?: number;
}

interface GetBusySlotsDto {
  params: BusySlotParamsDto;
  companyId: number;
}

interface BusySlotsResponseDto {
  [key: string]: boolean;
}

export const orderSlotsApiSlice = createApi({
  baseQuery: fakeBaseQuery(),
  reducerPath: 'orderSlotsApiSlice',
  endpoints: (build) => ({
    getHolidays: build.query<string[], GetHolidaysDto>({
      queryFn: ({ companyId, params }) =>
        BackendApiClient.request({
          method: 'GET',
          url: `/companies/${companyId}/disabled-pre-order-dates`,
          params,
        }).then((res) => {
          if (res.success) {
            return { data: res.response.data, status: res.status };
          }

          return {
            error: {
              data: res.response,
              status: res.status,
            },
          };
        }),
    }),
    getBusySlots: build.query<BusySlotsResponseDto, GetBusySlotsDto>({
      queryFn: ({ companyId, params }) =>
        BackendApiClient.request({
          method: 'GET',
          url: `/companies/${companyId}/scheduled-order-busy-slots`,
          params,
        }).then((res) => {
          if (res.success) {
            return { data: res.response.data, status: res.status };
          }

          return {
            error: {
              data: res.response,
              status: res.status,
            },
          };
        }),
    }),
  }),
});

export const { useGetHolidaysQuery, useGetBusySlotsQuery } = orderSlotsApiSlice;
